
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"width":"28px","height":"28px"},style,staticStyle],
              attrs: Object.assign({"style":"width:28px;height:28px","viewBox":"0 0 23 23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#515358","d":"M15 12c-1.11 0-2 .89-2 2a2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2m-3 8a8 8 0 01-8-8 8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8m0-18A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2m2 7a2 2 0 00-2-2c-1.11 0-2 .89-2 2a2 2 0 002 2 2 2 0 002-2m-5 3a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/bundle_svgs/bundle.svg